(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ErrorView", [], factory);
	else if(typeof exports === 'object')
		exports["ErrorView"] = factory();
	else
		root["ErrorView"] = factory();
})(this, function() {
return 